import { ClassTableFrame } from '@features/class/components/ClassTableFrame'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_layout/_teacher-portal/groups/classes/$classId/access-arrangements')({
    component: () => <ClassTableFrame columnGroup={'accessArrangements'} />,
    staticData: {
        crumb: {
            label: 'Access Arrangements'
        }
    }
})